<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("performancereport") }}</div>
      <div class="mt-3 mb-4 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getPerformanceReportFromDate"
                  v-on:click="
                    onPerformanceReportDateHandlerV2({
                      event: null,
                      name: 'fromDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onPerformanceReportDateHandlerV2({
                      event: $event,
                      name: 'fromDate'
                    })
                  "
                  ref="programaticOpen"
                  :value="getPerformanceReportFromDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getPerformanceReportFromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="getPerformanceReportToDate"
                  v-on:click="
                    onPerformanceReportDateHandlerV2({
                      event: null,
                      name: 'toDate'
                    })
                  "
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  @selected="
                    onPerformanceReportDateHandlerV2({
                      event: $event,
                      name: 'toDate'
                    })
                  "
                  ref="programaticOpen"
                  :value="getPerformanceReportToDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="getPerformanceReportToDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div
            v-if="!getPerformanceReportsIsCinema"
            class="col-lg-6 col-xl-3 align-self-center mb-3"
          >
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  getPerformanceReportSelectedCinema.length > 0
                    ? 'shift-up'
                    : ''
                "
              >
                {{ $tc("cinema", 1) }}
              </label>
              <b-dropdown
                :text="getPerformanceReportSelectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in Cinemas"
                  :key="dropdownIndex"
                  @click="
                    onPerformanceReportDropdownHandler({
                      event: $event,
                      name: 'Cinema',
                      selectedItem: dropdownItem,
                      index: dropdownIndex
                    });
                    searchCinema = '';
                    onSearchCinema();
                    onSelectCinema(dropdownItem);
                  "
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="fetchPerformanceReportListV2"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <!-- <b-dropdown id="listview" variant="outline-blue-lg">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{selectedvalue}}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
            >{{list.name}}</b-dropdown-item>
        </b-dropdown>-->
      </div>
      <div class="table-scroll">
        <table
          v-if="getPerformanceReportList.length === 0"
          class="performance-report-table mb-2"
          border="1"
        >
          <thead>
            <tr>
              <td colspan="2"></td>
              <td colspan="3">{{ $t("audience") }}</td>
              <td colspan="5">{{ $t("revenue") }}</td>
              <td colspan="2">ATP</td>
            </tr>
            <tr>
              <td>{{ $t("film") }}</td>
              <td>{{ $t("noof") }} {{ $t("show") }}</td>
              <td>{{ $t("admits") }}</td>
              <td>{{ $tc("screen", 1) }} {{ $t("capacity") }}</td>
              <td>{{ $t("occupancy") }} %</td>
              <td>BOR</td>
              <!-- New -->
              <td>Offers / Vouchers</td>
              <!-- New -->
              <td>{{ $t("tax") }}</td>
              <td>{{ $t("service") }} {{ $t("charge") }}</td>
              <td>Nett BOR</td>
              <td>BOR ATP</td>
              <td>{{ $t("net") }} ATP</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="12">
                <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-scroll">
        <table
          v-if="getPerformanceReportList.length > 0"
          class="performance-report-table"
          border="1"
        >
          <thead>
            <tr>
              <td colspan="2"></td>
              <td colspan="3">Audience</td>
              <td :colspan="3 + getPerformanceReportChargeList.length">
                {{ $t("revenue") }}
              </td>
              <td colspan="2">ATP</td>
            </tr>
            <tr>
              <td>{{ $t("film") }}</td>
              <td>{{ $t("noof") }} {{ $t("show") }}</td>
              <td>{{ $t("admits") }}</td>
              <td>{{ $tc("screen", 1) }} {{ $t("capacity") }}</td>
              <td>{{ $t("occupancy") }} %</td>
              <td>BOR</td>
              <!-- New -->
              <td>Offers / Vouchers</td>
              <!-- New -->
              <td
                v-for="(Charge, ChargeIndex) in getPerformanceReportChargeList"
                :key="ChargeIndex"
              >
                <span>{{ Charge.ct_name }}</span>
              </td>
              <!-- <td>CGST</td>
            <td>SGST</td>-->
              <td>Nett BOR</td>
              <td>BOR ATP</td>
              <td>Net ATP</td>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(PerformanceReportList,
              PerformanceReportListIndex) in getPerformanceReportList"
              :key="PerformanceReportListIndex"
              class="light_grey_back"
            >
              <td>
                <div style="text-align:left;">
                  {{ PerformanceReportList.movie_name }}
                </div>
                <div style="text-align:left;">
                  {{ PerformanceReportList.screen_name }}
                </div>
                <!-- <div>Screen 2</div>
              <div>Screen 3</div>-->
              </td>
              <td>
                <div>&nbsp;</div>
                <div style="text-align:right;">
                  {{ PerformanceReportList.no_of_show }}
                </div>
                <!-- <div>8</div>
              <div>12</div>-->
              </td>
              <td>
                <div>&nbsp;</div>
                <div style="text-align:right;">
                  {{ PerformanceReportList.tickets }}
                </div>
              </td>
              <td>
                <div>&nbsp;</div>
                <div style="text-align:right;">
                  {{ PerformanceReportList.screen_count }}
                </div>
              </td>
              <td>
                <div>&nbsp;</div>

                <div style="text-align:right;">
                  {{
                    PerformanceReportList.tickets &&
                    PerformanceReportList.screen_count &&
                    PerformanceReportList.no_of_show
                      ? currFormat(
                          (parseFloat(PerformanceReportList.tickets) /
                            (parseFloat(PerformanceReportList.screen_count) *
                              parseFloat(PerformanceReportList.no_of_show))) *
                            100
                        )
                      : 0
                  }}
                </div>
              </td>
              <td>
                <div>&nbsp;</div>
                <div style="text-align:right;">
                  {{ currFormat(PerformanceReportList.gross_revenue) }}
                </div>
              </td>
              <!-- New -->
              <td>
                <div>&nbsp;</div>
                <div style="text-align:right;">
                  {{ currFormat(PerformanceReportList.offer_price) }}
                </div>
              </td>
              <!-- New -->

              <td
                v-for="(ChargeItem,
                ChargeIndex) in getPerformanceReportChargeList"
                :key="ChargeIndex + ChargeItem.ChargeName + ChargeItem.ct_name"
              >
                <div>&nbsp;</div>
                <div style="text-align:right;">
                  {{
                    PerformanceReportList[
                      ChargeItem.ct_name + "_" + ChargeItem.ct_id
                    ]
                      ? ChargeItem.pas_is_rebate &&
                        ChargeItem.pas_is_rebate === "Y"
                        ? -currFormat(
                            PerformanceReportList[
                              ChargeItem.ct_name + "_" + ChargeItem.ct_id
                            ]
                          )
                        : currFormat(
                            PerformanceReportList[
                              ChargeItem.ct_name + "_" + ChargeItem.ct_id
                            ]
                          ) || "-"
                      : "_"
                  }}
                </div>
              </td>

              <!-- <td>0</td>
            <td>0.00</td>-->
              <td>
                <div>&nbsp;</div>
                <div style="text-align:right;">
                  {{
                    PerformanceReportList.net_revenue &&
                    PerformanceReportList.no_of_show
                      ? currFormat(
                          PerformanceReportList.net_revenue /
                            PerformanceReportList.no_of_show
                        )
                      : 0
                  }}
                </div>
              </td>
              <td>
                <div>&nbsp;</div>
                <div style="text-align:right;">
                  {{
                    PerformanceReportList.gross_revenue &&
                    PerformanceReportList.tickets
                      ? currFormat(
                          PerformanceReportList.gross_revenue /
                            PerformanceReportList.tickets
                        ) || "-"
                      : 0
                  }}
                </div>
              </td>
              <td>
                <div>&nbsp;</div>
                <div style="text-align:right;">
                  {{
                    PerformanceReportList.net_revenue &&
                    PerformanceReportList.tickets
                      ? currFormat(
                          PerformanceReportList.net_revenue /
                            PerformanceReportList.tickets
                        )
                      : 0
                  }}
                </div>
              </td>
            </tr>
            <!-- <tr>
            <td></td>
            <td>
              <strong>24</strong>
            </td>
            <td>
              <strong>81</strong>
            </td>
            <td>
              <strong>2,1488</strong>
            </td>
            <td></td>
            <td>
              <strong>4,578</strong>
            </td>
            <td>
              <strong>218</strong>
            </td>
            <td>
              <strong>0.00</strong>
            </td>
            <td>
              <strong>4,360</strong>
            </td>
            <td>
              <strong>56.0</strong>
            </td>
            <td>
              <strong>53.3</strong>
            </td>
          </tr>-->
          </tbody>
        </table>
      </div>

      <div
        v-if="getPerformanceExcelFileName"
        class="d-flex justify-content-end mt-5 align-items-center"
      >
        <div>{{ $t("download") }} as:</div>
        <a
          v-if="getPerformancePdfFileName"
          :href="BASE_URL + getPerformancePdfFileName"
          target="_blank"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>

        <a
          v-if="getPerformanceExcelFileName"
          :href="BASE_URL + getPerformanceExcelFileName"
          target="_blank"
          title="Download as Excel"
          download
        >
          <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
        </a>
      </div>
    </div>

    <div class="white-wrapper">
      <h5>Concession Sale Analysis</h5>
      <table class="concession-analysis-table">
        <thead>
          <tr>
            <th colspan="1" style="width:20%">Item</th>
            <th colspan="4">Units</th>
            <th colspan="4">Value</th>
          </tr>

          <tr>
            <th></th>
            <th>Qty Sold</th>
            <th>Net Price</th>
            <th>Std Profit</th>
            <th>Std Profit %</th>
            <th>Net Sale</th>
            <th>Sale Mix</th>
            <th>Net Profit</th>
            <th>Profit Mix</th>
          </tr>
        </thead>
        <tbody class="border-bottom border-dark">
          <!-- CREATE THIS TR ONLY FIRST TIME -->
          <tr>
            <td>
              <strong>F&B</strong>
            </td>
            <td colspan="11"></td>
          </tr>
        </tbody>
        <tbody
          class="border-bottom border-dark"
          v-for="(PerformanceConcessionReports,
          PerformanceConcessionReportsIndex) in getPerformanceConcessionReportsList"
          :key="PerformanceConcessionReportsIndex"
        >
          <tr
            v-for="(SingleItem,
            SingleIndex) in PerformanceConcessionReports.FoodCategory"
            :key="SingleIndex"
          >
            <td>
              <p v-if="SingleIndex === 0">{{ SingleItem.fc_category }}</p>
              {{ SingleItem.item_name }}
            </td>
            <td>
              <p v-if="SingleIndex === 0">&nbsp;</p>
              {{ SingleItem.fst_quantity }}
            </td>
            <td>
              {{
                SingleItem["net_price"] ? currFormat(SingleItem.net_price) : ""
              }}
            </td>
            <td>
              {{
                SingleItem["std_profit"]
                  ? currFormat(SingleItem.std_profit)
                  : ""
              }}
            </td>
            <td>
              {{
                SingleItem["std_profit"] && SingleItem["net_price"]
                  ? currFormat(
                      (SingleItem.std_profit / SingleItem.net_price) * 100
                    )
                  : ""
              }}
            </td>

            <td>
              {{
                SingleItem["net_sales"] ? currFormat(SingleItem.net_sales) : ""
              }}
            </td>
            <td>
              {{
                SingleItem["net_sales"] && SingleItem["total_net_sales"]
                  ? currFormat(
                      (SingleItem.net_sales / SingleItem.total_net_sales) * 100
                    )
                  : ""
              }}
            </td>
            <td>
              {{
                SingleItem["net_profit"]
                  ? currFormat(SingleItem.net_profit)
                  : ""
              }}
            </td>
            <td>
              {{
                SingleItem["net_profit"] && SingleItem["total_std_profit"]
                  ? currFormat(
                      (SingleItem.net_profit / SingleItem.total_std_profit) *
                        100
                    )
                  : ""
              }}
            </td>
          </tr>
        </tbody>
        <tbody class="border-bottom border-dark">
          <tr>
            <td>
              <strong>F&amp;B</strong>
            </td>

            <td>
              <strong>{{ getPerformanceRecordsTotal.qtySold }}</strong>
            </td>
            <td>
              <strong>{{
                currFormat(getPerformanceRecordsTotal.netPrice)
              }}</strong>
            </td>
            <td>
              <strong>{{
                currFormat(getPerformanceRecordsTotal.stdProfit)
              }}</strong>
            </td>
            <td>
              <strong>{{
                currFormat(getPerformanceRecordsTotal.stdProfitPercentage)
              }}</strong>
            </td>
            <td>
              <strong>{{
                currFormat(getPerformanceRecordsTotal.netSale)
              }}</strong>
            </td>
            <td>
              <strong>{{
                currFormat(getPerformanceRecordsTotal.saleMix)
              }}</strong>
            </td>
            <td>
              <strong>{{
                currFormat(getPerformanceRecordsTotal.netProfit)
              }}</strong>
            </td>
            <td>
              <strong>{{
                currFormat(getPerformanceRecordsTotal.profitMix)
              }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import MasterService from "@/services/MasterService";
import { mapState, mapGetters, mapActions } from "vuex";
import { BASEURL } from "@/config/index";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords
  },
  data() {
    return {
      BASEURL,
      Cinemas: [],
      CinemasCopy: [],
      searchCinema: ""
    };
  },
  computed: {
    ...mapGetters([
      // Flags
      "getPerformanceReportsIsCinema",
      // End
      // Get Only
      "getCinemasList",
      //
      "getPerformanceReportChargeList",
      "getPerformanceReportList",

      "getPerformanceConcessionReportsList",
      "getPerformanceRecordsTotal",

      "getPerformanceReportToDate",
      "getPerformanceReportFromDate",
      "getPerformanceReportSelectedCinema",

      // EXCEL
      "getPerformanceExcelFileName",

      // PDF
      "getPerformancePdfFileName"
    ])
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      if (CinemaObj) {
        this.onPerformanceReportDropdownHandler({
          event: null,
          name: "Cinema",
          selectedItem: CinemaObj
        });
      }
    }
  },
  beforeMount() {
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;

    this.getCinemaList(cinemaId);

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onPerformanceReportDropdownHandler({
        event: null,
        name: "Cinema",
        selectedItem: CinemaObj
      });
    }
    // this.fetchCinemasList({cinemaId});
    // this.onPerformanceReportFlagHandler({
    //   event: null,
    //   name: "isCinema",
    //   value: cinemaId
    // });
    // this.onPerformanceReportFlagHandler({
    //   event: null,
    //   name: "isCountry",
    //   value: this.secureStore.get("BRGLOPCO") || null
    // });
  },
  mounted() {},
  methods: {
    onSelectCinema(cinema) {
      this.$store.dispatch("selectDropdownCinema", cinema);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function(cine_id) {
      this.Cinemas = [];
      //  let payload = null
      //   cine_id == null ?  payload = {tableName : 'ms_cinemas',cine_is_active: "Y"} : payload = {tableName : 'ms_cinemas',cine_is_active: "Y" ,cine_id : cine_id }
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                // let cinema = {
                //   cine_name: x.cine_name,
                //   cine_id: x.cine_id
                // };

                this.onPerformanceReportDropdownHandler({
                  name: "Cinema",
                  selectedItem: { cine_name: x.cine_name, cine_id: x.cine_id }
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    ...mapActions([
      "fetchPerformanceReportListV2",
      "onPerformanceReportDateHandlerV2",
      "fetchCinemasList",
      "onPerformanceReportDropdownHandler",
      "onPerformanceReportFlagHandler",
      "onResetPerformanceReportStoreState"
    ])
  },
  beforeDestroy: async function() {
    await this.$store.dispatch("globalRemoveFile", {
      fileName: this.getPerformanceExcelFileName
    });
    await this.onResetPerformanceReportStoreState();
  }
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/performanceReportV2.vue